export default __webpack_public_path__ + "static/media/greenStarPoints-1.c3a4013d.png";